import React from "react";
import {useTranslation} from "react-i18next";
import {Form, Input} from "antd";
import dayjs from "dayjs";

const {TextArea} = Input

export const AdmissionAcceptForm = ({
                                      formRef, formData, infoOfOrder, onValuesChange, executorData, edit
                                    }:any) => {
  const { t } = useTranslation('admissionNotes');


  return (
    <Form layout="vertical" onValuesChange={onValuesChange} form={formRef} autoComplete="off" name="accept_note_form">
      <p>{t("acceptNote.receiptTitle")} № {!edit ? formData.note_number : null}</p>

      {
        !edit ? null
          : <Form.Item name='note_number' label={t("acceptNote.receiptTitleForm")}
                       rules={[{ required: true, message: t("acceptNote.error") }]}>
            <Input placeholder={t("acceptNote.receiptTitleForm")}/>
          </Form.Item>
      }

      <p>{t("acceptNote.listOfTakenDocument", {name: infoOfOrder.data && infoOfOrder.data.educationOrder ?
          (infoOfOrder.data.educationOrder.parent_name ? (`${infoOfOrder.data.educationOrder.parent_surname} ${infoOfOrder.data.educationOrder.parent_name} ${infoOfOrder.data.educationOrder.parent_patronymic_entrant}`)
            : infoOfOrder.data.educationOrder.name_entrant ? (`${infoOfOrder.data.educationOrder.name_entrant} ${infoOfOrder.data.educationOrder.surname_entrant} ${infoOfOrder.data.educationOrder.patronymic_entrant}`) : 'smth with parent or entrant')
          : 'smth with infoOfOrder' })}</p>

      {
        !edit ? <p> {formData.comment} </p> :
          null
      }

      {!edit ? null :
        <Form.Item name='comment' label={t("rejectNote.comment.label")}
                   rules={[{ required: true, message: t("rejectNote.comment.placeholder1")}]}>
          <TextArea rows={4} placeholder={t("rejectNote.comment.placeholder2")}/>
        </Form.Item>
      }


      <p className='executor-caption'>{executorData && executorData.executor ? executorData.executor.fio : 'Исполнитель не найден'}</p>
      <p className='executor-subtitle'>{t("executorLabel")}</p>


      <p>{t("dateOfReceipt")} {dayjs().format('DD.MM.YYYY')}</p>
      {/*{!edit ? `Дата получения расписки: ${moment(formData.date).format('DD.MM.YYYY')}` :*/}
      {/*  <Form.Item name="date" label="Дата получения расписки"*/}
      {/*             rules={[{ required: true, message: 'Необходимо выбрать дату!' }]}>*/}
      {/*    <DatePicker style={{ width: '13%' }} locale={locale} placeholder='«‎___» ______________ 20__ года‎'*/}
      {/*                value={dateOfNote} format='‎DD/MM/YYYY' disabled={!edit}*/}
      {/*                onChange={(date) => setDateOfNote(date)}/>*/}
      {/*  </Form.Item>*/}
      {/*}*/}
    </Form>
  )
}